import { Stack } from '@ui-components/neo.tax';
import { ReactComponent as Lock } from '@ui-components/neo.tax/dist/icons/lock-closed.svg';
import FocusLock from 'react-focus-lock';

import { useUnlockedElementIds } from './hooks';
import { LockContainer, LockTextContainer, StyledSubtitle, StyledTitle } from './lock-header.styled';

type LockHeaderProps = {
  locked?: boolean;
  reason?: string;
  children?: React.ReactNode;
};

export const LockHeader = ({ children, locked, reason }: LockHeaderProps): React.ReactElement | null => {
  // allow user to log out even when the page is locked
  const unlockedElementIds = useUnlockedElementIds();

  if (!locked) {
    return null;
  }
  return (
    <FocusLock whiteList={(element): boolean => !unlockedElementIds.has(element.id)}>
      <LockContainer alignItems="center" gap={3} boxShadow="md">
        <Lock width={20} />
        <LockTextContainer justifyContent="space-between">
          <Stack alignItems="center" gap={2}>
            <StyledTitle fontSize="sm" fontWeight="medium">
              Page Is Locked
            </StyledTitle>
            {reason ? (
              <StyledSubtitle fontSize="sm" fontWeight="normal">
                {reason}
              </StyledSubtitle>
            ) : null}
          </Stack>
          <Stack>{children}</Stack>
        </LockTextContainer>
      </LockContainer>
    </FocusLock>
  );
};
